import { useState, useRef } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Tooltip } from 'react-tooltip';
import DatosCabezaFamilia from '../DatosCabezaFamilia.jsx';
import apiService from '../../../Auth/apiService.jsx';
import SweetAlert2 from 'react-sweetalert2';
import 'react-datepicker/dist/react-datepicker.css';
import DatePicker from 'react-datepicker';
import MenuCaracterizacion from '../Componentes/MenuCaracterizacion.jsx';
import { useAuth } from '../../../Auth/AuthContext.jsx';
import SearchForm from '../../Utils/Searchform.jsx';
import SeccionPageHeader from '../../Utils/SeccionPageHeader.jsx';
import CargandoSpinner from '../../Utils/CargandoSpinner.jsx';
import { useAtencionForm, CustomInput } from './common/AtencionShared.jsx';
import { Card, Row, Col } from 'react-bootstrap';

export default function Juridico(){
    const navigate = useNavigate();
    const { token, user, rol, sedeActual } = useAuth();
    const { idCabezaFamilia, idDerivacion } = useParams();
    const { control, handleSubmit, watch, register, setError, clearErrors, setValue, reset, formState: { errors }} = useForm(
        {
            defaultValues: {
                ate_detallederivacionid: idDerivacion || '0', // use '0' as default if idDerivacion is undefined
            }

        }
    );
    const [hideGuardar, setHideGuardar] = useState(false);
    const fileInputRef = useRef(null);
    
    const {
        Cargando,
        swalProps,
        setSwalProps,
        Mensaje,
        entidades,
        ayudas,
        integrantes,
        sedes,
        CabezaFamiliaDatos,
        resetForm,
    } = useAtencionForm({ token, idCabezaFamilia, rol, user, sedeActual, setValue, reset, fetchUrl: '/reparacion/crearformulariojuridico' });
    const [searchTerm, setSearchTerm] = useState('');
    const radicadoIngresoField = register('str_radicadoingreso');
    const radicadoIngreso = watch('str_radicadoingreso');
    const hasRadicadoIngreso = Boolean(String(radicadoIngreso ?? '').trim());
    
    const handleSearch = (event) => {
        event.preventDefault();
        if (searchTerm.trim() !== '') {
            navigate(`/caracterizacion/juridico/${searchTerm}/${idDerivacion}`, { replace: true });
        }
    };
    const onSubmit = async (data) => {
        if(integrantes.find((item) => item.per_idpersona === data.idpersona).per_fallecido === 'SI'){
            Mensaje('Registrar atencion', "No se puede registrar atencion a un integrante fallecido");
            return;
        }
        setHideGuardar(true);
        // normalize fecha to yyyy-MM-dd string
        if (data.fecha instanceof Date) {
            const d = data.fecha;
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            data.fecha = `${y}-${m}-${day}`;
        }
        let url;
        url = '/reparacion/registraratencionjuridico';
        try {
            const fileNameValue = data.act_filename || '';
            if (fileNameValue) {
                let nameOnly = fileNameValue.replace(/\.[^/.]+$/, '');
                // Remove special characters and spaces, keep only alphanumeric
                nameOnly = nameOnly.replace(/[^A-Za-z0-9]/g, '');
                // Trim to 50 characters
                nameOnly = nameOnly.substring(0, 50);
                // Check if name is empty after cleaning
                if (!nameOnly) {
                    Mensaje('Registrar atencion', 'El nombre del archivo es inválido después de limpiar caracteres especiales');
                    return;
                }
                // Update the data with sanitized filename
                const extension = fileNameValue.match(/\.[^/.]+$/)?.[0] || '';
                data.act_filename = nameOnly + extension;
            }
            // validate file size if a raw File object exists
            const fileObj = data.act_file_obj;
            if (fileObj instanceof File) {
                const MAX_BYTES = 5 * 1024 * 1024;
                if (fileObj.size > MAX_BYTES) {
                    setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                    setValue('act_filename', '', { shouldValidate: false });
                    setValue('act_file_obj', null, { shouldValidate: false });
                    setError('act_file', { type: 'size', message: 'El archivo excede el tamaño máximo de 5 MB' });
                    return;
                }
            }
            // ensure act_file is a base64 string (set in file onChange)
            // remove file object placeholder before sending JSON
            const payload = { ...data };
            if (payload.act_file_obj) delete payload.act_file_obj;
            if (payload.str_radicadoingreso === '') {
                payload.str_radicadoingreso = null;
                payload.dat_fechaingreso = null;
                payload.dat_fechasalida = null;
            }
            const response = await apiService.post(url, payload, token);
            if (response.status === 200) {
                Mensaje('Registrar atenci&oacute;n', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Registrar atencion', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setHideGuardar(false);
            resetForm();
            // clear file fields and input element on reset
            setValue('act_file', null, { shouldValidate: false, shouldDirty: false });
            setValue('act_filename', '', { shouldValidate: false, shouldDirty: false });
            setValue('act_file_obj', null, { shouldValidate: false, shouldDirty: false });
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Registrar atenci&oacute;n jur&iacute;dica" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Registrar atencion" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    <SearchForm searchTerm={searchTerm} setSearchTerm={setSearchTerm} handleSearch={handleSearch} Cargando={Cargando} />
                    <Card>
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => navigate('/caracterizacion/listaratencionjuridica/' + idCabezaFamilia)}
                            >
                                Ver atenciones jur&iacute;dicas
                            </button>
                        </div>
                    </Card>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-info">
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                <DatosCabezaFamilia datos={CabezaFamiliaDatos} />
                                <input hidden {...register('usrId')}/>
                                <input hidden {...register('cabIdcabezafamilia')}/>
                                <input hidden {...register('ate_detallederivacionid')}/>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='entidad'>Entidad:</label>
                                            <select id='entidad' {...register('entidad', { required: true })} className='form-control' >
                                                {entidades.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                {option.entEntidad}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.entidad && <p style={{color: 'red'}}>Seleccione entidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='ayuda'>Atenci&oacute;n:</label>
                                            <select id='ayuda' {...register('ayuda', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ayudas.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.ayuAyuda}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.ayuda && <p style={{color: 'red'}}>Seleccione atencion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='idpersona'>Integrante:</label>
                                            <select id='idpersona' {...register('idpersona', { required: true })} className='form-control' >
                                                {integrantes.map((option) => (
                                                <option key={option.per_idpersona} value={option.per_idpersona}>
                                                    {option.par_parentesco} {option.per_idpersona} {option.nombre} {option.per_fallecido === 'SI' ? '(Fallecido)' : ''}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.idpersona && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='fecha'>Fecha atenci&oacute;n</label>
                                            <Controller
                                                id="fecha"
                                                control={control}
                                                name="fecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fecha && <p style={{color: 'red'}}>Digite fecha de atencion</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='cantidad'>Cantidad</label>
                                            <input id='cantidad' className="form-control" 
                                                {...register('cantidad', { required: true })}
                                                placeholder="cantidad"/>
                                            {errors.cantidad && <p style={{color: 'red'}}>Digite cantidad</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='sede'>Sede:</label>
                                            <select id='sede' {...register('sede', { required: true })} className='form-control'>
                                                {sedes.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.sedNombre}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.sede && <p style={{color: 'red'}}>Seleccione sede</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor='str_radicadoingreso'>Radicado de ingreso</label>
                                            <input 
                                                type='text' 
                                                id='str_radicadoingreso' 
                                                className="form-control" 
                                                {...radicadoIngresoField}
                                                onChange={(e) => {
                                                    radicadoIngresoField.onChange(e);
                                                    if (e.target.value === ''){
                                                        setValue('dat_fechaingreso', null)
                                                        setValue('dat_fechasalida', null)
                                                    }
                                                }}
                                                placeholder="radicado de ingreso"/>
                                            {errors.str_radicadoingreso && <p style={{color: 'red'}}>Digite radicado de ingreso</p>}
                                        </div>
                                    </div>
                                    {hasRadicadoIngreso && <div className="col-md-6">
                                        <Row className="mb-12">
                                            <Col md={4}>
                                                <label htmlFor='dat_fechaingreso'>Fecha ingreso</label>
                                                <Controller
                                                    id="dat_fechaingreso"
                                                    control={control}
                                                    name="dat_fechaingreso"
                                                    rules={{
                                                        validate: (value) => {
                                                            if (hasRadicadoIngreso && !value) {
                                                                return 'Digite fecha de ingreso';
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <DatePicker
                                                        placeholderText="fecha"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                        />
                                                    )}
                                                />
                                                {errors.dat_fechaingreso && <p style={{color: 'red'}}>Digite fecha de ingreso</p>}
                                            </Col>
                                            <Col md={4}>
                                                <label htmlFor='dat_fechasalida'>Fecha salida</label>
                                                <Controller
                                                    id="dat_fechasalida"
                                                    control={control}
                                                    name="dat_fechasalida"
                                                    rules={{
                                                        validate: (value) => {
                                                            if (hasRadicadoIngreso && !value) {
                                                                return 'Digite fecha de salida';
                                                            }
                                                            return true;
                                                        }
                                                    }}
                                                    render={({ field }) => (
                                                        <DatePicker
                                                        placeholderText="dat_fechasalida"
                                                        onChange={(date) => field.onChange(date)}
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        selected={field.value}
                                                        customInput={<CustomInput />}
                                                        locale="es"
                                                        dateFormat="yyyy-MM-dd"
                                                        maxDate={new Date()}
                                                        />
                                                    )}
                                                />
                                                {errors.dat_fechasalida && <p style={{color: 'red'}}>Digite fecha de salida</p>}
                                            </Col>
                                        </Row>
                                    </div>}
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observaciones">Observaciones</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observaciones', { required: true })}
                                                placeholder="observaciones"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observacionDos">Atenci&oacute;n jur&iacute;dica</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={5} style={{ width: '100%' }}
                                                {...register('observacionDos', { required: true })}
                                                placeholder="observaciones jur&iacute;dicas"
                                            />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="act_file">Subir archivo PDF</label>
                                            <input
                                                type="file"
                                                accept="application/pdf"
                                                className="form-control"
                                                multiple={false}
                                                ref={fileInputRef}
                                                onChange={(e) => {
                                                    const f = e.target.files?.[0];
                                                    // reset previous errors/values
                                                    clearErrors(['act_file', 'act_filename', 'act_file_obj']);
                                                    if (!f) {
                                                        setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                        setValue('act_filename', '', { shouldValidate: false });
                                                        setValue('act_file_obj', null, { shouldValidate: false });
                                                        return;
                                                    }
                                                    if (f.type !== 'application/pdf') {
                                                        setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                        setValue('act_filename', '', { shouldValidate: false });
                                                        setError('act_file', { type: 'type', message: 'Solo se permiten archivos PDF' });
                                                        return;
                                                    }
                                                    let nameOnly = f.name.replace(/\.[^/.]+$/, ''); // strip extension
                                                    // Remove special characters and spaces, keep only alphanumeric
                                                    nameOnly = nameOnly.replace(/[^A-Za-z0-9]/g, '');
                                                    // Trim to 50 characters
                                                    nameOnly = nameOnly.substring(0, 50);
                                                    // Check if name is empty after cleaning
                                                    if (!nameOnly) {
                                                        setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                        setValue('act_filename', '', { shouldValidate: false });
                                                        setError('act_filename', { type: 'pattern', message: 'El nombre del archivo es inválido después de limpiar caracteres especiales' });
                                                        return;
                                                    }
                                                    const reader = new FileReader();
                                                    reader.onload = (ev) => {
                                                        const dataUrl = ev.target?.result || '';
                                                        if (typeof dataUrl !== 'string' || !dataUrl.includes(',')) {
                                                            setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                            setValue('act_filename', '', { shouldValidate: false });
                                                            setValue('act_file_obj', null, { shouldValidate: false });
                                                            return;
                                                        }
                                                        const base64 = dataUrl.split(',')[1] || '';
                                                        setValue('act_file', base64, { shouldValidate: true, shouldDirty: true });
                                                        // store only the validated name (keep extension if needed)
                                                        setValue('act_filename', f.name, { shouldValidate: false, shouldDirty: false });
                                                        // also store the raw file object for multipart submissions
                                                        setValue('act_file_obj', f, { shouldValidate: false, shouldDirty: true });
                                                    };
                                                    reader.onerror = () => {
                                                        setValue('act_file', null, { shouldValidate: true, shouldDirty: true });
                                                        setValue('act_filename', '', { shouldValidate: false });
                                                        setValue('act_file_obj', null, { shouldValidate: false });
                                                    };
                                                    reader.readAsDataURL(f);
                                                }}
                                                aria-label="Seleccionar archivo (PDF)"
                                            />
                                            <input type="hidden" {...register('act_file')} />
                                            {errors.act_file && <p style={{ color: 'red' }}>{errors.act_file.message || 'Ingrese archivo'}</p>}
                                            <input type="hidden" {...register('act_filename')} />
                                            {errors.act_filename && <p style={{ color: 'red' }}>{errors.act_filename.message || 'Nombre de archivo inválido'}</p>}
                                            <input type="hidden" {...register('act_file_obj')} />
                                            {errors.act_file_obj && <p style={{ color: 'red' }}>{errors.act_file_obj.message || 'Ingrese archivo'}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        {!hideGuardar &&
                                            <button type="submit" className="btn btn-primary">Guardar</button>
                                        }
                                        {hideGuardar &&
                                            <button type="button" className="btn btn-primary" disabled>Guardando...</button>
                                        }
                                    </div>
                                </div>
                                </div>
                            </form>
                        </div>
                        {/* /.card */}

                        </div>
                        {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
}